module.exports = __webpack_public_path__ + "img/weddings_07_V.5ccb8063.webp";